import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useSearchParams } from "react-router-dom";
import FilterBar from "../components/FilterBar";
import KPIs from "../components/KPIs";
import HeroChart from "../components/HeroChart";
import CategoryChart from "../components/CategoryChart";
import TopProducts from "../components/TopProducts";
import StoresChart from "../components/StoresChart";
import OrderSizeChart from "../components/OrderSizeChart";
const VALID_PERIODS = ["ytd", "mtd", "qtd", "30d", "90d"];
function parseFilters(params) {
    const period = params.get("period");
    const stores = params.get("stores");
    return {
        period: period && VALID_PERIODS.includes(period) ? period : "ytd",
        stores: stores ? stores.split(",").filter(Boolean) : ["all"],
    };
}
export default function Dashboard() {
    const [params, setParams] = useSearchParams();
    const filters = parseFilters(params);
    function setFilters(f) {
        const next = new URLSearchParams();
        next.set("period", f.period);
        if (f.stores.length && !f.stores.includes("all")) {
            next.set("stores", f.stores.join(","));
        }
        setParams(next, { replace: true });
    }
    const storeIds = filters.stores.includes("all") ? [] : filters.stores;
    return (_jsxs(_Fragment, { children: [_jsx(FilterBar, { filters: filters, setFilters: setFilters }), _jsxs("main", { className: "dash", children: [_jsxs("header", { className: "dash-head", children: [_jsxs("div", { children: [_jsxs("div", { className: "eyebrow-num", children: [_jsx("span", { className: "idx", children: "01" }), _jsx("span", { children: "YTD overview" })] }), _jsx("h1", { children: "How is the Jaffle business doing?" }), _jsx("div", { className: "sub", children: "Year-to-date through May 20, 2026 \u00B7 Six stores \u00B7 Snapshot of the metrics that matter." })] }), _jsxs("div", { className: "right", children: [_jsx("span", { children: "As of" }), _jsx("span", { className: "big", children: "Wed \u00B7 May 20, 2026" }), _jsx("span", { children: "Synthetic Jaffle Shop data" })] })] }), _jsx(KPIs, { period: filters.period, stores: storeIds }), _jsx(HeroChart, { period: filters.period, stores: storeIds }), _jsxs("div", { className: "chart-grid", children: [_jsx(CategoryChart, { period: filters.period, stores: storeIds }), _jsx(TopProducts, { period: filters.period, stores: storeIds })] }), _jsxs("div", { className: "chart-grid", children: [_jsx(StoresChart, { period: filters.period }), _jsx(OrderSizeChart, { period: filters.period, stores: storeIds })] })] })] }));
}
